interface WizardHeaderProps {
  step: number;
  isManga: boolean;
  isUkiyo: boolean;
  mangaTitles?: string[];
  ukiyoTitles?: string[];
  totalSteps?: number;
}

const DEFAULT_MANGA_TITLES = ['WELCOME', 'YOUR INTERESTS'];
const DEFAULT_UKIYO_TITLES = ['Welcome', 'Interests'];

export function WizardHeader({
  step,
  isManga,
  isUkiyo,
  mangaTitles = DEFAULT_MANGA_TITLES,
  ukiyoTitles = DEFAULT_UKIYO_TITLES,
  totalSteps = 2,
}: WizardHeaderProps) {
  if (isManga) {
    return (
      <div style={{
        background: '#0a0a0a',
        borderBottom: '4px solid #0a0a0a',
        padding: '16px 20px 12px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} style={{
            position: 'absolute', height: 1, width: '200%', background: '#fff',
            top: `${8 + i * 8}%`, left: '-50%',
            transform: `rotate(${-6 + (i % 5) * 3}deg)`,
            opacity: 0.04 + (i % 3) * 0.02, pointerEvents: 'none',
          }} />
        ))}
        <div style={{ position: 'relative' }}>
          <div>
            <div style={{
              display: 'inline-block', background: '#fff', color: '#0a0a0a',
              fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 9, fontWeight: 900,
              letterSpacing: '0.22em', textTransform: 'uppercase', padding: '2px 9px',
              transform: 'skewX(-5deg)', marginBottom: 6,
            }}>
              <span style={{ display: 'inline-block', transform: 'skewX(5deg)' }}>
                {mangaTitles[step] || mangaTitles[0]}
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={{
                background: '#E8192C', color: '#fff',
                fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 9, fontWeight: 900,
                letterSpacing: '0.12em', padding: '2px 7px',
              }}>
                CH.{step + 1}
              </div>
              <div style={{
                background: '#fff', color: '#0a0a0a',
                fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 9, fontWeight: 900,
                letterSpacing: '0.12em', padding: '2px 7px',
              }}>
                VOL.1
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isUkiyo) {
    return (
      <div style={{
        position: 'relative', height: 110, overflow: 'hidden', background: '#2C5F8A',
        borderRadius: '16px 16px 0 0',
      }}>
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(180deg, #2C5F8A 0%, #6B9FBE 55%, #B8D4E0 85%, #DCE8F0 100%)',
        }} />
        <div style={{
          position: 'absolute', right: 160, top: 14, width: 44, height: 44,
          borderRadius: '50%',
          background: 'radial-gradient(circle at 40% 38%, #FFE88A 0%, #F5C842 55%, #D4A017 100%)',
          boxShadow: '0 0 18px 5px rgba(244,200,60,0.26)', zIndex: 2,
        }} />
        <svg style={{ position: 'absolute', bottom: 22, right: 30, width: 130, height: 80, zIndex: 2, overflow: 'visible' }}
          viewBox="-8 0 216 130">
          <polygon points="100,4 122,36 166,130 208,130" fill="#A0B8CC" opacity="0.32" />
          <polygon points="100,4 -8,130 208,130" fill="#C8D8E8" stroke="#A8BECC" strokeWidth="0.6" />
          <polygon points="100,4 74,36 126,36" fill="white" opacity="0.94" />
          <line x1="68" y1="42" x2="132" y2="42" stroke="white" strokeWidth="0.6" opacity="0.5" />
        </svg>
        <svg style={{ position: 'absolute', bottom: 0, left: 0, right: 0, zIndex: 3 }}
          viewBox="0 0 800 60" preserveAspectRatio="none" width="100%">
          <path d="M0 35 Q30 22 60 32 Q100 45 140 28 Q180 12 220 28 Q260 44 300 28 Q340 14 380 28 Q420 44 460 28 Q500 14 540 28 Q580 44 620 28 Q660 12 700 28 Q740 44 800 32 L800 60 L0 60 Z"
            fill="#0D3A6B" opacity="0.95" />
          <path d="M-10 42 Q20 28 50 38 Q80 50 110 36 Q140 22 170 36 Q200 50 230 36 Q260 22 290 36 Q320 50 350 36 Q380 22 410 36 Q440 50 470 36 Q500 22 530 36 Q560 50 590 36 Q620 22 650 36 Q680 50 710 36 Q740 22 800 36 L800 60 L-10 60 Z"
            fill="#1B5C8A" />
          <path d="M0 52 Q25 44 50 50 Q80 58 110 50 Q140 44 170 50 Q200 58 230 50 Q260 44 290 50 Q320 58 350 50 Q380 44 410 50 Q440 58 470 50 Q500 44 530 50 Q560 58 590 50 Q620 44 650 50 Q680 58 710 50 Q740 44 800 50 L800 60 L0 60 Z"
            fill="#4A8AB0" />
        </svg>
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 6,
          display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0 20px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 4 }}>
            <div style={{ width: 14, height: 1.5, background: '#B8860B' }} />
            <span style={{
              fontFamily: "'Noto Serif JP', serif", fontSize: 10,
              letterSpacing: '0.35em', color: '#B8860B',
            }}>
              {'令和八年'} · Step {step + 1} of {totalSteps}
            </span>
          </div>
          <h2 style={{
            fontFamily: "'Noto Serif JP', serif", fontSize: 28, fontWeight: 700,
            color: '#fff', lineHeight: 1, textShadow: '0 2px 10px rgba(0,0,0,0.35)',
            margin: '0 0 4px',
          }}>
            {ukiyoTitles[step] || ukiyoTitles[0]}
          </h2>
          <div style={{ width: 30, height: 2, background: 'linear-gradient(90deg, #C0392B, #B8860B)' }} />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-900 dark:bg-gray-950 rounded-t-2xl px-5 py-3 flex items-center">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 bg-secondary-500 rounded-lg flex items-center justify-center">
          <span style={{ fontFamily: "'Noto Serif JP', serif", color: '#fff', fontSize: 14, fontWeight: 700 }}>
            {'旅'}
          </span>
        </div>
        <span className="text-white text-sm font-semibold tracking-wide">TripGenesys Japan</span>
      </div>
    </div>
  );
}
